import { GroupDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/groupdto';
import { PaginationListViewModelImpl } from 'src/com/sixdee/crbtportal/ui/toolkit/verticallist/paginationverticallist/paginationlistviewmodel';
import { ListGroupRowComponent } from './listgrouprowcomponent';
import * as React from 'react';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';

export class ListGroupViewModelImpl extends PaginationListViewModelImpl<GroupDto>
{
    constructor(position:number,context: BaseContext, private onDelete: any, private onView:any, private onEdit:any)
    {
        super(position,context);
        this.onDeleteClick = this.onDeleteClick.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
        this.onViewClick = this.onViewClick.bind(this);

    }

    getView(t: GroupDto, position: number): boolean | JSX.Element 
    {
        return <ListGroupRowComponent onViewClick={this.onViewClick} onEditClick={this.onEditClick} onDeleteClick={this.onDeleteClick} key={position}  context={this.getContext()} groupDto={t}  position={position}/>;
    }

    onViewClick(groupDto:GroupDto):void
    { 
          this.onView(groupDto);
    }

    onEditClick(groupDto:GroupDto):void
    {
         this.onEdit(groupDto);
    }

    onDeleteClick(groupDto:GroupDto):void
    {
         this.onDelete(groupDto);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/listgroup/viewmodel/grouprow/listgroupviewmodel.tsx